module.exports = __webpack_public_path__ + "static/img/banner_b.2cbbc41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_b.jpg
// module id = yYAq
// module chunks = 1